import { useQuery } from '@apollo/client/react'
import { PortalPaymentGatewaysDocument } from '@/graphql/generated/graphql'

export interface GatewayCurrency {
  id: number
  name: string
}

export interface PortalGateway {
  id: number
  name: string
  code: string
  allowedCurrencies: GatewayCurrency[]
}

/**
 * Pasarelas de pago disponibles en el autoservicio del portal (externas de
 * Zeus ∩ habilitadas por el admin del portal). Si la lista queda vacía el
 * paso de pago no puede completarse (el admin debe habilitar alguna).
 */
export function usePaymentGateways() {
  const { data, loading, error, refetch } = useQuery(
    PortalPaymentGatewaysDocument,
  )
  const gateways: PortalGateway[] = (data?.portalPaymentGateways ?? []).map(
    (g) => ({
      id: g.id,
      name: g.name,
      code: g.code,
      allowedCurrencies: (g.allowedCurrencies ?? []).map((c) => ({
        id: c.id,
        name: c.name,
      })),
    }),
  )
  return { gateways, loading, error, refetch }
}
